import { gql } from '@apollo/client';

export const CLOSE_KPI_FORMULA_MUTATION = gql`
  mutation CloseKpiFormula($id: Int!) {
    p {
      closeKpiFormula(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
